<template>
  <vs-alert
    v-if="errors.length > 0"
    color="danger"
    title="Atenção!!"
    active="true"
    class="my-3"
    style="height: auto !important"
  >
    <ul>
      <li class="mb-2" v-for="(error, index) in errors" :key="index">
        {{ error }}
      </li>
    </ul>
  </vs-alert>
</template>
<script>
export default {
  name:'Errors-Alert',
  props: ['errors'],
};
</script>
